export default __webpack_public_path__ + "static/media/plant.45d76770.png";